// src/app/core/signalr/types.ts

export enum ExportStatusView {
  None = 'None',
  Exporting = 'Exporting',
  Complete = 'Complete',
  Failed = 'Failed',
}

export interface ExportStatusPayload {
  status: ExportStatusView;
  totalSops: number;
  completedSops: number;
  percent: number;
  downloadUrl: string | null;
  failureReason: string | null;
}
